"use client";

import type { ReactElement } from "react";
import { LandingPageContent } from "./home-page/LandingPageContent";
import { LandingPageModalLayer } from "./home-page/LandingPageModalLayer";
import { LandingPagePrepageOverlay } from "./home-page/LandingPagePrepageOverlay";
import { TeamsGalleryTweaksHost } from "./home-page/TeamsGalleryTweaksHost";
import { useHomePageController } from "./home-page/useHomePageController";

export default function HomePage(): ReactElement {
  const controller = useHomePageController();

  // The tweaks host wraps BOTH landing subtrees: the deck and the standalone
  // team overlay live in the modal layer, the deploy preflight lives in the
  // content tree, and all three must read one set of design selections.
  return (
    <TeamsGalleryTweaksHost>
      <LandingPageContent controller={controller} />
      <LandingPageModalLayer controller={controller} />
      <LandingPagePrepageOverlay showPrepage={controller.showPrepage} />
    </TeamsGalleryTweaksHost>
  );
}
